import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { saveShippingAddress } from '../../../../actionCreators/checkout';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import SideBarPopup from '../../../components/SideBarPopup/SideBarPopup';
import ShippingAddress from '../../Checkout/ShippingAddress/ShippingAddress';
import ReturnAddress from './ReturnAddress';

function ShippingAddressExchange(props) {
  const {
    setIsExpandable,
    saveShippingAddress,
    userAddress,
    returnIdItem,
    orderDetails,
    dataLocale,
    setFinalStep,
    exchangeShippingAddress,
    isExpandable,
    setFifthStep,
    isExchangeOnlyCase,
  } = props; // saveUserAddress
  const {
    ADD_POWER,
    CHANGE,
    SHIPPING_ADDRESS,
    SYMBOL_COLON,
    NEXT,
    SELECT_SHIPPING_ADDRESS,
    ADD_SELECT_ADDRESS,
    WHERE_DO_YOU_WANT_TO_SHIP_THE_EXCHANGE_ITEM,
    SAVE_ADDRESS,
  } = dataLocale;
  const [isScheduledPickUpPopUpOpen, setIsScheduledPickUpPopUpOpen] = useState(false);
  const returnStep = sessionStorageHelper.getItem('returnStep') || {};
  const [selectedAddress, setSelectedAddress] = useState();
  const [address, setAddress] = useState();
  const [renderAddress, setRenderAddress] = useState(returnStep?.renderAddress);
  const shippingAddress =
    orderDetails &&
    orderDetails.result &&
    orderDetails.result.orders &&
    orderDetails.result.orders[0] &&
    orderDetails.result.orders[0].shippingAddress;

  useEffect(() => {
    const shipAddress = sessionStorageHelper.getItem('ShippingAddress') || {};
    if (!exchangeShippingAddress) {
      setAddress(shipAddress || shippingAddress);
    }
  }, [shippingAddress]);

  useEffect(() => {
    const shipAddress = sessionStorageHelper.getItem('ShippingAddress') || {};
    setAddress(shipAddress || shippingAddress);
    if (shipAddress) {
      const shippingAddressJson = {};
      shippingAddressJson.address = shipAddress;
      saveShippingAddress(shippingAddressJson);
    }
  }, []);

  useEffect(() => {
    const shipAddress = sessionStorageHelper.getItem('ShippingAddress') || {};
    if (exchangeShippingAddress) {
      let shippedAddress = '';
      const productShippingAddress = shipAddress.postcode ? shipAddress : shippingAddress;
      if (productShippingAddress) {
        if (productShippingAddress.addressline1)
          shippedAddress += `${productShippingAddress.addressline1} `;
        if (productShippingAddress.addressline2)
          shippedAddress += `${productShippingAddress.addressline2} `;
        if (productShippingAddress.city) shippedAddress += `${productShippingAddress.city} `;
        if (productShippingAddress.state) shippedAddress += `${productShippingAddress.state} `;
        if (productShippingAddress.postcode) shippedAddress += productShippingAddress.postcode;
      }
      setRenderAddress(shippedAddress);
      let returnStep = sessionStorageHelper.getItem('returnStep') || {};
      returnStep = {
        ...returnStep,
        renderAddress: shippedAddress,
      };
      sessionStorageHelper.setItem('returnStep', returnStep);
    }
  }, [exchangeShippingAddress]);

  const handleChange = () => {
    setIsExpandable('Shipping Address');
    setFifthStep(false);
    setFinalStep('');
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    returnStep = {
      ...returnStep,
      isExpandable: 'Shipping Address',
      fifthStep: false,
      finalStep: '',
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
  };
  const handleNext = () => {
    setIsExpandable(ADD_POWER);
    setFifthStep(true);
    setFinalStep('Exchange');
    const shipAddress = sessionStorageHelper.getItem('ShippingAddress') || {};
    const shippingAddressJson = {};
    shippingAddressJson.address = shipAddress;
    saveShippingAddress(shippingAddressJson);

    let shippedAddress = '';
    const productShippingAddress =
      shipAddress && shipAddress.postcode ? shipAddress : shippingAddress;
    if (productShippingAddress) {
      if (productShippingAddress.addressline1)
        shippedAddress += `${productShippingAddress.addressline1} `;
      if (productShippingAddress.addressline2)
        shippedAddress += `${productShippingAddress.addressline2} `;
      if (productShippingAddress.city) shippedAddress += `${productShippingAddress.city} `;
      if (productShippingAddress.state) shippedAddress += `${productShippingAddress.state} `;
      if (productShippingAddress.postcode) shippedAddress += productShippingAddress.postcode;
    }
    setRenderAddress(shippedAddress);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    returnStep = {
      ...returnStep,
      isExpandable: ADD_POWER,
      fifthStep: true,
      finalStep: 'Exchange',
      renderAddress: shippedAddress,
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
  };
  return (
    <div className="bora-8 margin-10 order-box">
      <div className={`padding-15 ${isExpandable !== 'Shipping Address' ? 'bg-white' : 'bg-cyan'}`}>
        <span
          className={`fs15 futur-std  ${
            isExpandable !== 'Shipping Address' ? 'text-color-grey fw500' : 'fw600'
          }`}
        >
          {`${
            isExchangeOnlyCase || returnIdItem ? 2 : 4
          }. ${WHERE_DO_YOU_WANT_TO_SHIP_THE_EXCHANGE_ITEM}`}
        </span>
        {isExpandable !== 'Shipping Address' && (
          <span className="float-right margin-r10 text-uppercase text-link" onClick={handleChange}>
            {CHANGE}
          </span>
        )}
        {isExpandable !== 'Shipping Address' && (
          <div className="margin-t5">
            <span className="margin-l20">
              {SHIPPING_ADDRESS}
              {SYMBOL_COLON}{' '}
            </span>
            <span className="margin-l8 text-color-grey">{renderAddress}</span>
          </div>
        )}
      </div>
      {isExpandable === 'Shipping Address' && (
        <>
          {address ? (
            <div className="margin-l33 margin-r25 margin-t5 margin-b5">
              <ReturnAddress
                addressType={SHIPPING_ADDRESS}
                changeAddress={() => setIsScheduledPickUpPopUpOpen(true)}
                pickupLabel={`${address.firstName ? address.firstName : ''} ${
                  address.lastName ? address.lastName : ''
                }`}
                userAddress={address}
              />
            </div>
          ) : (
            ''
          )}
          {isScheduledPickUpPopUpOpen && (
            <SideBarPopup
              dialogClassName="power-type-modal"
              open={isScheduledPickUpPopUpOpen}
              onClose={setIsScheduledPickUpPopUpOpen}
            >
              <div style={{ margin: '36px' }}>
                <div className="fs20 fw500">{SELECT_SHIPPING_ADDRESS}</div>
                <div className="fs14 fw400 color-lightgrey">{ADD_SELECT_ADDRESS}</div>
                <div className="fs14 bold margin-t22 color-lightgrey">{SAVE_ADDRESS}</div>
                <ShippingAddress
                  isReturnExchange
                  ReturnExchange_onSubmitAddress={address => {
                    setAddress(address);
                    const shippingAddressJson = {};
                    shippingAddressJson.address = address;
                    saveShippingAddress(shippingAddressJson);
                    let ShippingAddress = sessionStorageHelper.getItem('ShippingAddress') || {};
                    ShippingAddress = { ...address };
                    sessionStorageHelper.setItem('ShippingAddress', ShippingAddress);
                  }}
                  defaultUserAddress={userAddress}
                  selectedAddress={selectedAddress}
                  setIsScheduledPickUpPopUpOpen={val => setIsScheduledPickUpPopUpOpen(val)}
                  // pageName="returnExchange"
                  setSelectedAddress={setSelectedAddress}
                />
              </div>
            </SideBarPopup>
          )}
          {(exchangeShippingAddress || address) && (
            <Button
              className="float-right margin-t15 margin-r15 text-color-white bg-color-primary no-decoration flex-basis-20 text-center block bora-4 fw700 text-uppercase"
              onClick={handleNext}
            >
              {NEXT}
            </Button>
          )}
        </>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    exchangeShippingAddress: state.checkout.saveShippingAddress,
    userAddress: state.returnExchange.userAddress,
    orderDetails: state.order.orderDetails,
    dataLocale: state.locale,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    saveShippingAddress: (data, isExchange) => dispatch(saveShippingAddress(data, isExchange)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShippingAddressExchange);
